import isNil from 'lodash/isNil';
import { summaryStore } from 'state/store';
import { selectUserId } from './auth';

export const selectSummaryStatus = () => {
    return summaryStore.status;
};

export const selectSummaryParticipants = () => {
    return summaryStore.participants;
};

export const selectCoolDownRecording = () => {
    return summaryStore.coolDownRecording;
};

export const selectStoppedByServer = () => {
    return summaryStore.stoppedByServer;
};

export const selectIsSummarizing = () => {
    const participants = selectSummaryParticipants();
    const coolDownRecording = selectCoolDownRecording();
    const isSummarizing = !isNil(participants) && isNil(coolDownRecording);

    return isSummarizing;
};

export const selectIsMeSubscribedToSummary = () => {
    const participants = selectSummaryParticipants();
    const myId = selectUserId();

    if (!participants || !myId) return false;

    return Boolean(participants[myId]);
};

export const selectSomeoneStartedSummary = () => {
    const isSummarizing = selectIsSummarizing();
    const isMeSubscribedToSummary = selectIsMeSubscribedToSummary();

    return isSummarizing && !isMeSubscribedToSummary;
};

export const selectIsSummaryHasBeenInitByMe = () => {
    return summaryStore.isInitByMe;
};
